import { defineStore } from 'pinia'

function detectLanguage() {
  // 1. 优先使用 localStorage 保存的用户手动选择
  const saved = localStorage.getItem('locale')
  if (saved) return saved
  
  // 2. 检测浏览器语言
  const browserLang = navigator.language || navigator.userLanguage || ''
  
  // 3. 匹配中文则返回 zh-CN，否则 en-US
  if (browserLang.startsWith('zh')) return 'zh-CN'
  return 'en-US'
}

export const useLocaleStore = defineStore('locale', {
  state: () => ({
    locale: detectLanguage(),
  }),
  actions: {
    setLocale(newLocale) {
      this.locale = newLocale
      localStorage.setItem('locale', newLocale)
    },
  },
  persist: { key: 'locale', storage: localStorage },
})
